import React from 'react';
import { Button, Col, Input, Modal, ModalFooter, ModalBody, ModalHeader, Row } from 'reactstrap';

class EmailInputModal extends React.Component {

    handleOnEmailChange = (e) => {
        const newEmail = { ...this.props.personEmail, emailAddress: e.target.value };
        this.props.onChange(newEmail);
    };


    handleOnIsPrimaryChange = (e) => {
        const newEmail = this.props.personEmail;
        newEmail.isPrimary = e.target.checked;
        this.props.onChange(newEmail);
    }

    handleSave = () => {
        this.props.onSave();
        this.props.onToggle();
    }

    testValidEmail = () => {
        const { personEmail } = this.props;
        const emailRegex = /^[A-Z0-9_'%=+!`#~$*?^{}&|-]+([.][A-Z0-9_'%=+!`#~$*?^{}&|-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)+$/i;

        if (!personEmail.emailAddress) {
            return true; 
        } else if (emailRegex.test(personEmail.emailAddress)) {
            return false;
        } else {
            return true; 
        }
    }

    render() {
        return (
            <Modal
                isOpen={this.props.isOpen}
                toggle={this.props.onToggle}
                size='lg'
            >
                <ModalHeader toggle={this.props.toggle}>Add / Edit Email Address</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Input type="tel" id="Email" name="Email"
                                placeholder="Enter Valid Email"
                                required
                                value={this.props.personEmail.emailAddress}
                                onChange={this.handleOnEmailChange}
                                maxLength={50}
                            />
                        </Col>
                        <Col className='d-flex align-items-center'>
                            <Input
                                id='isPrimary'
                                name='IsPrimary'
                                type='checkbox'
                                label="Primary"
                                checked={this.props.personEmail.isPrimary}
                                onChange={this.handleOnIsPrimaryChange}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button disabled={this.testValidEmail()} color="primary" onClick={this.handleSave}>Save</Button>{' '}
                    <Button color="secondary" onClick={this.props.onToggle}>Cancel</Button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default EmailInputModal;